import {customAxiosBE} from "../config";

export async function getDepotsAPI(onlyActive) {
    const params = onlyActive === undefined ? "" : `?onlyActive=${onlyActive}`;
    return customAxiosBE.get(`/depot${params}`);
}

export async function insertDepotAPI(payload) {
    return customAxiosBE.post(`/depot`, payload);
}

export async function updateDepotAPI(id, payload) {
    return customAxiosBE.put(`/depot/${id}`, payload);
}

export async function deleteDepotAPI(id) {
    return customAxiosBE.delete(`/depot/${id}`);
}
